import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { NavigationAction } from '../_models/navigation.models';

export const NavigationActions = createActionGroup({
  source: 'Navigation',
  events: {
    'Update Menu Navigation': props<{ menu: NavigationAction[] | null }>(),
  }
});
